import { Dispatch, SetStateAction, useState } from "react";
import cookies from "js-cookie";
import moment from "moment";
import { useRouter } from "next/router";
import { Button } from "components/button";
import { useNotify } from "hooks";
import { applyToSummerCamp } from "services/summerCamp";
import { Div } from "styles/typography";
import { formatCurrency } from "utils/generic-utils";
import { ModalFormWrapper } from "./application-form.style";
import FormStep1 from "./form-step12";

interface ISummerCampForm {
   setStep?: Dispatch<SetStateAction<number>>;
   details: any;
   step?: number;
}

const SummerCampForm = ({ details, step, setStep }: ISummerCampForm) => {
   const [formBody, setFormBody] = useState({});

   const steps = [
      <ApplicationForm
         setFormBody={setFormBody}
         formBody={formBody}
         setCurrentStep={setStep}
         key={2}
      />,
      <FormDataPreview details={details} formData={formBody} key={1} />,
   ];

   return <div>{steps[step as number]}</div>;
};

const ApplicationForm = ({ setFormBody, formBody, setCurrentStep }) => {
   return (
      <ModalFormWrapper width="75rem">
         <p className="title">Summer Camp Admission Application Form</p>
         <p className="description">
            Kindly fill in the form and you'd get a response <br /> from the school shortly
         </p>
         <p className="form-title">Pupil's Details</p>
         <FormStep1
            key={0}
            setFormBody={setFormBody}
            formBody={formBody}
            setCurrentStep={setCurrentStep}
         />
      </ModalFormWrapper>
   );
};

const FormDataPreview = ({ formData, details }) => {
   const { notify } = useNotify();
   const [isLoading, setIsLoading] = useState(false);
   const router = useRouter();

   const handleLoginRedirect = () => {
      notify({
         message: "Please log in to continue",
         variant: "error",
      });
      cookies.set("edusko-school-redirect", "true");
      cookies.set("edusko-school-redirect-path", router.asPath);
      router.push({
         pathname: "/signin",
         query: { from: `${router.pathname}` },
      });
   };

   async function onSubmit() {
      try {
         setIsLoading(true);
         const response: any = await applyToSummerCamp(details.id as string, {
            ...formData,
            callbackUrl: `${window.location.origin}/summer-camp?payment=success`,
         });

         cookies.set("edusko-summer-camp-details", JSON.stringify(details));

         notify({
            message: "You are been redirected to paystack...",
            variant: "info",
         });
         setTimeout(() => {
            window.open(response.result.data.authorization_url, "_self");
         }, 2000);
      } catch (error: any) {
         if (error?.response?.status === 401) {
            handleLoginRedirect();
         } else {
            notify({
               message: error.result.message || error.result.custom_message,
               variant: "error",
            });
         }
      } finally {
         setIsLoading(false);
      }
   }

   return (
      <ModalFormWrapper width="43.6rem" height="auto" padding="0" className="noPadding">
         <div className="form-preview-heading">
            <div className="form-first-box" />
            <div className="form-second-box" />
            <h3>Summer Camp Application</h3>
            <p>{details?.schoolName}</p>
            <p>{moment().format("DD/MM/YYYY")}</p>
         </div>

         <div className="form-preview">
            <div className="form-data">
               <span style={{ fontWeight: 500 }} className="title">
                  Description
               </span>
               <span style={{ fontWeight: 500 }} className="title">
                  Amount
               </span>
            </div>
            <div className="form-data">
               <span>Summer Camp Program Fee</span>
               <span>{formatCurrency(details?.applicationFee, "NGN")}</span>
            </div>
            <div className="form-data">
               <span>Edusko Service Fee</span>
               <span>{formatCurrency(5000, "NGN")}</span>
            </div>
         </div>
         <div className="hr"></div>
         <div className="form-total-data">
            <span style={{ fontWeight: 500 }}>Total</span>
            <span>{formatCurrency(5000 + +details?.applicationFee, "NGN")}</span>
         </div>

         <Div marginTop="50px" padding="1rem" flex marginBottom="48px">
            <Button
               onClick={onSubmit}
               isLoading={isLoading}
               type="button"
               variant="primary"
               width="18.3rem"
            >
               Make Payment
            </Button>
         </Div>
      </ModalFormWrapper>
   );
};

export default SummerCampForm;
